let sample = [
    {
        id:0,
        title:"퍼퓸 디스커버리 세트",
        imgUrl:"/img/sample.jpg",
        content:"퍼퓸의 10가지 향",
        price:42000
    },

    {
        id:1,
        title:"퍼퓸 밤 디스커버리 세트",
        imgUrl:"/img/sample2.jpg",
        content:"퍼퓸밤의 4가지 향",
        price:4500
    },

    {
        id:2,
        title:"튜브 핸드 샘플 키트",
        imgUrl:"/img/sample3.jpg",
        content:"튜브 핸드크림의 6가지 향",
        price:3500
    },

    {
        id:3,
        title:"퍼퓸 쉘 엑스 오브제 디스커버리 세트(석고방향제)",
        imgUrl:"/img/sample4.jpg",
        content:"쉘 엑스 핸드크림의 세가지 향",
        price:9500
    }
]

export default sample;